export default __webpack_public_path__ + "static/media/0003.46b94c82.jpg";